export const getDaysDiffFromCurrentDateTimestamp = (daysDiffFromCurrentDate: number) => {
    const earlierDateByTimeDiff = new Date();
    earlierDateByTimeDiff.setDate(earlierDateByTimeDiff.getDate() - daysDiffFromCurrentDate);
    return earlierDateByTimeDiff.getTime();
}